import React from 'react';
import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { useStateSelector } from '../../store/selectors';
import { canAccessVenue } from '../access/venue-access-matrix';
import { isVenueAccessException } from '../access/venue-access-exceptions';
import { VenueId } from '../../venues/venues.types';
import { VENUES } from '../../venues/venues.config';
import { USER_ROLES } from '../../utils/constants';
import { paths } from '../path';

export interface RequireVenueAccessProps {
    venueId?: VenueId;
}

export const RequireVenueAccess = (props: RequireVenueAccessProps) => {
    const params = useParams<{ venueId: VenueId }>();
    const resolvedVenueId = props.venueId ?? params.venueId;
    const summary = useStateSelector((state) => state.userSummary.summary);
    const location = useLocation();

    const isValidVenue = resolvedVenueId && VENUES.some((v) => v.id === resolvedVenueId);
    if (!isValidVenue) {
        return <Navigate to={paths.account.venueSelection} replace />;
    }

    const isAdmin = summary?.roleId === USER_ROLES.ADMIN;

    if (summary && !isAdmin && !canAccessVenue(summary, resolvedVenueId as VenueId)) {
        const isException = isVenueAccessException(
            resolvedVenueId as VenueId,
            location.pathname,
            summary.roleId
        );
        if (!isException) {
            return <Navigate to={paths.account.venueSelection} replace />;
        }
    }

    return <Outlet />;
};
